import type { ShiftsByType } from "@/api/Capacity";
import { shiftTypeSchema, type IShiftType } from "@medoma/models/shifts";

// Admin, Center, and Introduction shifts do not provide capacity so they are not included
const includedShiftTypes: IShiftType[] = [
  shiftTypeSchema.enum.Ambulating,
  shiftTypeSchema.enum.Doctor,
  shiftTypeSchema.enum.External,
  shiftTypeSchema.enum.InHouse,
];

export const getIncludedShifts = (shiftsByType: ShiftsByType) =>
  shiftsByType.filter((shift) => includedShiftTypes.includes(shift.type));

export const calculateIncludedShiftsCount = (shiftsByType: ShiftsByType) =>
  getIncludedShifts(shiftsByType).reduce(
    (acc, curr) => acc + curr.staffedCount,
    0,
  );
